<template>


  <v-form
    ref="frmAppointment"
    v-model="isValid"
  >
    <v-container
      class="pa-0 ma-0 " 
      style="height: 500px"               
      >        

        <v-row
          class="pt-5 ma-0 px-0 pb-0"               >
          <v-col cols="12"
              class="pa-0 ma-0"
          >

          <v-text-field light flat dense
              class="fs-18"
              label="Name"
              background-color="ycmd-very-lightest-gray"
              v-model="localName" 
              :rules="requiredRules"
              ref="txtShiftName"
              :disabled="readOnly"
              />

          </v-col>
        </v-row>


        <v-row
          class="ma-0 pa-0" 
        >
          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <time-entry
              v-model="localStartTime"
              backgroundColor="ycmd-very-lightest-gray"
              :rules="requiredRules"
              label="Start Time"
              class="pr-1"
              :disabled="readOnly"

            />
          </v-col>
          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <time-entry
              v-model="localEndTime"
              backgroundColor="ycmd-very-lightest-gray"
              :rules="requiredRules"
              label="End Time"
              class="pl-1"
              :disabled="readOnly"

            />
          </v-col>    
          <v-col cols="6"
              class="pa-0 ma-0"
          >
            <checkbox-list
              :items="dows"
              v-model="localWeekdays"
              :label="'Days'"
              :horizontal="true"
              :disabled="readOnly"
            />
          </v-col>                               
        </v-row>

        <v-row
          class="ma-0 pa-0" 
          align="center"
          v-if="showRounding"
        >

          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <v-checkbox
            label="Rounding Shift"
            v-model="localRounding"
            dense
            hide-details
            :disabled="readOnly || disabledRounding"                  
            />
          </v-col>     
          <v-col cols="9"
              class="pa-0 ma-0 font-weight-light fs-10 "
              style="line-height: 12px;"
          >
            Make this template/shift a Rounding template, and this shift can be used multiple times per day. Physicians on this template/shift will receive pages sent to them directly and messages will not be routed to any other shift, even if the filter/rules match.
          </v-col>                                               
        </v-row>

        <v-row
          class="ma-0 pa-0" 
          align="center"
          v-if="showRoundingOutpatient"
        >

          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <v-checkbox
            label="Rounding Shift + Outpatient Rounding"
            v-model="localRoundingOutpatient"
            dense
            hide-details
            :disabled="readOnly || disabledRounding"
            />
          </v-col>     
          <v-col cols="9"
              class="pa-0 ma-0 font-weight-light fs-10 "
              style="line-height: 12px;"
          >
              Same as rounding, but also, the oncall will take their own outpatient calls, only if they are selected. This shift will not have outpatients calls routed to.
          </v-col>                                               
        </v-row>

        <v-row
          class="ma-0 pa-0" 
          align="center"
          v-if="showRotation"
        >

          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <v-checkbox
            label="Rotating Shift"
            v-model="localRotation"
            dense
            hide-details
            :disabled="readOnly || disabledFromRounding"    
            />
          </v-col>     
          <v-col cols="9"
              class="pa-0 ma-0 font-weight-light fs-10 "
              style="line-height: 12px;"
          >
            Make this template/shift a rotating template. This means that multiple physicians can be active on this shift and messages are rotated to each person on the shift.

          </v-col>                                               
        </v-row>



        <v-row
          class="ma-0 pa-0" 
          align="center"
          v-if="showCatchall"
        >

          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <v-checkbox
            label="Catch-All Template"
            v-model="localCatchall"
            dense
            hide-details
            :disabled="readOnly || disabledFromRounding"    
            />
          </v-col>     
          <v-col cols="9"
              class="pa-0 ma-0 font-weight-light fs-10 "
              style="line-height: 12px;"
          >
            Make this template/shift a Catch-All template. This means any physician in this subgroup that is not on a shift who receives a message will instead route that message to the physician on this shift. Only one catch-all can be used per time period.
          </v-col>                                               
        </v-row>


        <v-row
          class="ma-0 pa-0" 
          align="center"
          v-if="showOutpatient"

        >

          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <v-checkbox
            label="Outpatient Catch-All Template"
            v-model="localOutpatient"
            dense
            hide-details
            :disabled="readOnly || disabledFromRounding"    
            />
          </v-col>     
          <v-col cols="9"
              class="pa-0 ma-0 font-weight-light fs-10 "
              style="line-height: 12px;"
          >
            Make this template/shift an Outpatient Catch-All template. This is the same as the catch-all, but only affects outpatient locations.
          </v-col>                                               
        </v-row>



        <v-row
          class="ma-0 pa-0" 
          align="center"
          v-if="showAssignNewPatient"

        >

          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <v-checkbox
            label="Assign New Patient"
            v-model="localAssignNewPatient"
            dense
            hide-details    
            :disabled="readOnly || disabledFromRounding"                  
            />
          </v-col>     
          <v-col cols="9"
              class="pa-0 ma-0 font-weight-light fs-10 "
              style="line-height: 12px;"
          >
            Make this template/shift into one that will auto-assign new patients to the receiving physician.
          </v-col>                                               
        </v-row>


        <v-row
          class="ma-0 pa-0" 
          align="center"
          v-if="showAssignTemporary"
        >

          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <v-checkbox
            label="Temporary Assignment"
            v-model="localAssignTemporary"
            :disabled="readOnly || disabledFromRounding"    
            dense
            hide-details
            />
          </v-col>     
          <v-col cols="9"
              class="pa-0 ma-0 font-weight-light fs-10 "
              style="line-height: 12px;"
          >
            Make this template/shift into one that will assign the patient temporarily to the receiving physician.
          </v-col>                                               
        </v-row>


        <v-row
          class="ma-0 pa-0" 
          v-if="showFacilities"                    
        >
          <v-col cols="12"
              class="pa-0 ma-0"
          >
            <checkbox-list
              :items="podFacilities"
              v-model="localSelectedFacilities"
              label="Facilities"
              :disabled="readOnly" 
            />       
            <template v-if="errorFacilities && errorFacilities.length">
              <checkbox-list
                :items="errorFacilities"
                v-model="errorFacilitiesSelected"
                label="Rounding Facility Errors"
                :disabled="readOnly" 
              />              
              <v-btn
                text
                @click="fixFacilities(errorFacilitiesSelected)"
                class="fs-10 text-none text-decoration-underline"
                :loading="sendingErrorFacilitiesSelected"
                :disabled="readOnly || ((!errorFacilitiesSelected || !errorFacilitiesSelected.length) ? true : false)"
              >
                Fix
              </v-btn>              
              <v-btn
                text
                @click="removeFromShift(errorFacilitiesSelected)"
                class="fs-10 text-none text-decoration-underline"
                :disabled="readOnly || ((!errorFacilitiesSelected || !errorFacilitiesSelected.length) ? true : false)"
              >
                Remove from Shift
              </v-btn>      
            </template>
          </v-col>
        </v-row>      
        <v-row
          class="ma-0 px-0 pb-0 pt-5" 
          v-if="showFilter"                    
        >
          <v-col cols="3"
              class="pa-0 ma-0"
          >

          </v-col>     

          <v-col cols="3"
              class="pa-0 ma-0"
          >

            <filter-select
              :pod_id="pod ? pod.id: null"
              :filters="filterItems"
              :group_id="group_id"
              :filter_id="localFilterId"
              label="Filter"
              @change="saveFilter"
              backgroundColor="ycmd-very-lightest-gray" 
              :disabled="readOnly"
            />


          </v-col>
        </v-row>     

        <v-row
          class="ma-0 pa-0" 
          v-if="showButtons"      
        >
          <v-col cols="12"
              class="pa-0 ma-0"
          >
          
            <v-btn
              text
              @click="cancel()"
              class="float-right"
            >
              Cancel
            </v-btn>              

            <v-btn
              text
              @click="save()"
              class="float-right"
            >
              Save
            </v-btn>  
          </v-col>
        </v-row>      
    </v-container>
  </v-form>
            
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import scheduleFilterSelect from '@/views/apps/scheduling-new/components/scheduleFilterSelect';
import timeEntry from '@/components/datetime/time-entry';
import checkboxList from '@/components/checkbox-list'
  export default {
    props: {
      shift: {
          type: Object,
          default: () => {}
      },  
      pod: {
          type: Object,
          default: () => {}
      },   
      filters: {
          type: Array,
          default: () => []
      },   
      group_id: {
          type: String,
          default: ''
      },  
      showButtons: {
          type: Boolean,
          default: false
      },
      reload: {
          type: String,
          default: ''
      },      
      readOnly: {
          default: false,
          type: Boolean
      },                  
    },
    components: {
      'time-entry': timeEntry,
      'checkbox-list': checkboxList,
      'filter-select':scheduleFilterSelect
    },    
    data: () => ({
      name: '',
      rules: {
          required: value => !!value || 'Required.',
          arrayRequired: (value) => {
            return !value ||  !value.length ? 'Required.' : true
          },
          shiftRules: []
      },
      isValid: true,
      localSelectedFacilities: [],
      localName: '',
      localStartTime: '',
      localEndTime: '',
      localWeekdays: [],
      localOutpatient: 0,
      localCatchall: 0,
      localAssignNewPatient: 0,
      localAssignTemporary: 0,
      localRotation: 0,
      localRounding: 0,
      localRoundingOutpatient: 0,
      localFilterId: null,
      dows: [
        {id: '0', name: 'Sunday'}, 
        {id: '1', name: 'Monday'},
        {id: '2', name: 'Tuesday'}, 
        {id: '3', name: 'Wednesday'},
        {id: '4', name: 'Thursday'},
        {id: '5', name: 'Friday'},
        {id: '6', name: 'Saturday'}
      ],

      initializing: false,
      validation_rules: {
        required: value => !!value || 'Required.',
      },
      errorFacilitiesSelected:null,
      sendingErrorFacilitiesSelected: false,
     }),
    mounted() {

      setTimeout(() => {
        this.$refs['txtShiftName'].focus()
      }, 300);
    },
    methods: {
      ...mapGetters('schedule',['getFacilityById']),
      ...mapActions('schedule',['removeFacilitiesFromPod','fixShiftRoundingFacilities']),

      async removeFromShift (facilities) {
        this.sendingErrorFacilitiesSelected = true

        let result = await this.removeFacilitiesFromShift({facility_ids: this.errorFacilitiesSelected, shift_id: this.shift.id})

        this.errorFacilitiesSelected = null
        let facMap = {}
        result.facilities.map(f => {
          facMap[f.id] = true
        }) 

        let newArray = []
        this.localSelectedFacilities.map(f => {
          if (!facMap[f]) {
            newArray.push(f)
          }
        })

        this.localSelectedFacilities = newArray

        this.sendingErrorFacilitiesSelected = false        
      },
      async fixFacilities (params) {

        let result = await this.fixShiftRoundingFacilities({facility_ids: this.errorFacilitiesSelected, shift_id: this.shift.id})

        if (result.pod && result.pod.facility_ids) {
          this.$set(this.pod,'facility_ids',result.pod.facility_ids)
        }

        if (params.callback) {
          params.callback({type: 'facilities'})
        }
      },      
      cancel() {
        this.$emit('cancel')
      },
      save() {
        this.$emit('save')
      },
      saveFilter(params) {
        this.localFilterId = params.filter_id
      },
      sendChanged(params) {
        if (!this.initializing) {
          this.$emit('changed', params)
        }
      },
      setLocalShift(newValue) {

        this.localSelectedFacilities = newValue.rounding_facilities
        this.localName = newValue.name
        this.localStartTime = newValue.start
        this.localEndTime = newValue.end
        this.localWeekdays = newValue.weekdays
        this.localOutpatient = !!newValue.outpatient
        this.localCatchall = !!newValue.catchall
        this.localAssignNewPatient = !!newValue.assign_new_patient
        this.localAssignTemporary = !!newValue.assign_temporary
        this.localRotation = !!newValue.rotation
        this.localRoundingOutpatient = false

        this.localRounding = !!newValue.rounding
        this.localFilterId = newValue.filter

        if (!this.localWeekdays.length) {
          this.localWeekdays = ["0","1","2","3","4","5","6"]
        }

      }
    },
    computed: {
      requiredRules () {
        return [this.validation_rules.required]
      },
      isLocalRounding () {
        if (this.localRounding || this.localRoundingOutpatient) {
          return true
        }
        return false
      },

      filterItems () {
        let sorted = this.filters.sort( (a,b) => {
            return a.name.localeCompare(b.name)
        })

        return sorted

      },
      showRoundingOutpatient () {
        return this.isNew
      },
      showOutpatient () {

        if (this.isNew) {
          return false
        } else {
          return this.shift.rounding ? false : true
        }
        
        return true
      },
      showAssignTemporary () {

        if (this.isNew) {
          return true
        } else {
          return this.shift.rounding ? false : true
        }
        return true
      },
      showAssignNewPatient () {

        if (this.isNew) {
          return true
        } else {
          return this.shift.rounding ? false : true
        }
        return true
      },
      showRotation () {

        //if (this.isNew) {
          //return true
        //} else {
          return this.shift.rounding ? false : true
        //}
        //return true
      },
      showCatchall () {
        if (this.isNew) {
          return true
        } else {

          return true

        }
        return false

      },
      showRounding () {
        return true
        if (this.isNew) {
          return true
        }
        if (this.shift.rounding) {
          return true
        }
      },
      showFilter () {
        if (this.isNew) {
          return this.isLocalRounding ? false : true
        } else {
          return this.shift.rounding ? false : true
        }
      },
      disabledRounding () {
        if (this.isNew) {
          if (this.localAssignNewPatient || this.localAssignTemporary || this.localRotation){
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
      disabledFromRounding () {
        if (this.isNew) {
          if (this.isLocalRounding) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      
      requiredRules () {
        return [this.rules.required]
      },      
      showFacilities () {
        if (this.isNew) {
          return this.isLocalRounding ? true : false
        } else {
          return this.shift.rotation || this.shift.rounding
        }
      },
      groupFacilitiesMap () {
        let map = {}
        let group = this.$store.getters['schedule/getGroupById'](this.group_id)

        if (group.facilities && group.facilities.length) {
          group.facilities.map(f => {
            map[f.id] = f
          })
        }
        return map
      },

      errorFacilities () {
        let arr = []
        let pfMap = {}
        let ids = []

        if (this.pod && this.pod.facility_ids && this.pod.facility_ids.length) {
          this.pod.facility_ids.map(id => {
            pfMap[id] = true
          })
        }

        let egfMap = this.groupFacilitiesMap      
        

        this.localSelectedFacilities.map(id => {
          let facility = this.$store.getters['schedule/getFacilityById'](id)
          let newfac = {
                id: facility.id,
                name: facility.name
              }

          let missingGroup= false
          if (!egfMap[id]) {
            missingGroup = true
          }
          let missingPod= false
          let missingBoth = false
          if (!pfMap[id]) {
            missingPod = true
          }

          missingBoth = missingGroup && missingPod

          let error = ''
          if (missingBoth) {
            error = 'Missing from Group and Pod'
          } else if (missingGroup) {
            error = 'Missing from Group'
          }
          else if (missingPod) {
            error = 'Missing from Pod'
          }
          newfac.html = `<span>${facility.name} <span style="color: red">${error}</span></span>`          

          if (error) {
            arr.push(newfac)
            ids.push(facility.id)
          }

        })

        let sorted = arr.sort( (a,b) => {
            return a.name.localeCompare(b.name)
        })

        if (!this.errorFacilitiesSelected) {
          this.errorFacilitiesSelected = ids
        }

        arr = sorted          


        return arr
      },      
      podFacilities () {
        let arr = []

        if (this.pod && this.pod.facility_ids && this.pod.facility_ids.length) {
          this.pod.facility_ids.map(id => {
            let fac = this.$store.getters['schedule/getFacilityById'](id)
            arr.push(fac)
          })  
          let sorted = arr.sort( (a,b) => {
              return a.name.localeCompare(b.name)
          })

          arr = sorted          
        }

        return arr
      },

      isNew () {
        if (this.shift && this.shift.id) {
          return false
        }
        return true
      }
                  
    },
    watch: {
      reload (newValue, oldValue) {
        this.setLocalShift(this.shift)            
      },
      localSelectedFacilities (newValue, oldValue) {
        this.sendChanged( {
          rounding_facilities: newValue
        })

      },
      localName (newValue, oldValue) {
        
        this.sendChanged( {
          name: newValue
        })

      },
      localStartTime (newValue, oldValue) {
        
        this.sendChanged( {
          start: newValue
        })
      },
      localEndTime (newValue, oldValue) {
        
        this.sendChanged( {
          end: newValue
        })
      },
      localWeekdays (newValue, oldValue) {
        this.sendChanged( {
          weekdays: newValue
        })
      },
      localOutpatient (newValue, oldValue) {
        
        this.sendChanged( {
          outpatient: newValue
        })
      },
      localCatchall (newValue, oldValue) {
        
        this.sendChanged( {
          catchall: newValue
        })
      },
      localAssignNewPatient (newValue, oldValue) {
        
        this.sendChanged( {
          assign_new_patient: newValue
        })
      },
      localAssignTemporary (newValue, oldValue) {
        
        this.sendChanged( {
          assign_temporary: newValue
        })
      },
      localRotation (newValue, oldValue) {
        
        this.sendChanged( {
          rotation: newValue
        })
      },
      localRoundingOutpatient (newValue, oldValue) {
        
        this.sendChanged( {
          rounding_outpatient: newValue
        })
        if (newValue) {

          //this.localRounding = false
        }

      },
      localRounding (newValue, oldValue) {

        this.sendChanged( {
          rounding: newValue
        })
        if (newValue) {
          //this.localRoundingOutpatient = false
        }
      },
      localFilterId (newValue, oldValue) {
        
        this.sendChanged( {
          filter: newValue
        })
      },
      
      shift: {
          handler (newValue, oldValue) {

            this.initializing = true

            this.setLocalShift(newValue)            
            
            setTimeout(()=> {

              this.initializing = false
            }, 500)

          }, 
          deep: true,
          immediate: true
      }
    }
  }
</script>

